import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/[lang]/not-authorized.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieCheck"] */ "/opt/build/repo/src/components/client/Breadcrumbs/CookieCheck.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Datalayer"] */ "/opt/build/repo/src/components/client/Datalayer/Datalayer.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/client/TabbedResourceGrid/ResourceGrid.css");
;
import(/* webpackMode: "eager", webpackExports: ["TabbedResourceGrid"] */ "/opt/build/repo/src/components/client/TabbedResourceGrid/TabbedResourceGrid.tsx");
